<template>
	<v-container fluid>
	  <material-wizard
		title="Importação de Dados"
		:subtitle="title"
		:loading="loading"
		v-model="tab"
		:minWidth="'700'"
		:maxWidth="'1500'"
		class="mx-auto"
		:available-steps="tabsLiberadas"
		:wizzardMixinsOn="true"
		:tabs="tabs"
		@click:next="nextStep()"
		@click:prev="prevStep()"
	  >
		<wizard-tabs
		  :itemsTipo="itemsTipo"
		  @step-observer="updateTabStatus($event)"
		  ref="wizardTabs"
		/>
	  </material-wizard>
	</v-container>
  </template>
  
  <script>
  import ImportacaoDados from '@/services/ImportacoesDadosService';
  import PreImportacoesDadosService from "@/services/PreImportacoesDadosService.js"
  import wizardMixins from '@/mixins/wizardMixins.js';
  import { filtrarTiposImportacaoDisponiveisV2 } from '@/utils/importacoesDados.js';
  
  export default {
	mixins: [wizardMixins],
  
	components: {
	  WizardTabs: () => import("@/components/importacoesDados/administracao/WizardTabs"),
	  MaterialWizard: () => import('@/components/base/MaterialWizard')
	},
  
	mounted() {
	  this.getTipoImportacao();
	},
  
	created() {
	  //this.iniciarPrimeiraTabTour();
	},
  
	computed:{
	  title() {
		if (this.tab == 0) {
		  return 'Faça upload do arquivo e preencha os paramentos'
		} else {
		  return 'Visualize as 10 primeiras linhas do arquivo e confirme'
		}
	  }
	},
  
	data: () => ({
	  itemsTipo:[],
	  loading:false,
	  arrayIndiceMapeados:[],
	  mapeamentos:{},
	  tabs: [
			"Inicio",
			"Mapeamento"
	  ],
	}),  
  
	methods:{
	  getTipoImportacao() {
		ImportacaoDados.getTipoImportacaoHexa()
		.then((resp) => {
			this.itemsTipo = filtrarTiposImportacaoDisponiveisV2(resp.data.data)
		})
		.catch(() => this.$toast.error(`Erro ao buscar o tipo da importacao.`, '', {position: 'topRight'}));
	  },
	  
		  nextStep() {
			if (this.tab === this.tabs.length - 1) {
			  this.save()
			} else {
			  this.tab++;
			}

				this.$forceUpdate();
		  },
  
	  
		  save() {
			if (!this.$refs.wizardTabs.validateBeforeSave()) return;

			this.loading = true;
			const data = this.$refs.wizardTabs.exportData();
			PreImportacoesDadosService.salvarPreImportacaoAdm(data).then(() => {
				this.$toast.success('Pre importação salva.', '',{position:'topRight'})
			this.$router.replace({ name: 'Importações de Dados Hexa' });
		})
		.catch((error) => {
				console.log(error)
				this.$toast.error('Erro ao salvar Importacao.', '',{position:'topRight'});
			})
			.finally(() => this.loading = false)
		  },
	}
  }
  </script>
